import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../hooks'
import { DatePicker } from '../../../DateTime'
import { FormikField } from '../../../Formik'
import { APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE } from '../../RentalPortalApplicant.constants'
import { getApplicantFormOptionalLabel } from '../../RentalPortalApplicant.utils'

function MoveInField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: getApplicantFormOptionalLabel({
          label: t('RentalPortal.ApplicantFormMoveInLabelKey'),
          t,
        }),
        shouldAdaptToMobileScreen: true,
      }}
      name={APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE}
    />
  )
}

export default MoveInField
